import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import classNames from 'classnames';
import {
  addMonths,
  getYear,
  getMonth,
  setDate,
  setMonth,
  getDaysInMonth
} from 'date-fns';

import { formatMonthAbbrvDate, getDateAsUTC } from '../utils/dateUtils';

import { getDaysDiff } from '../utils/DateRangeHandler';

import getOccupancies from './utils/getOccupancies';

import AvailabilityMonth from './AvailabilityMonth';

import styles from './AvailabilityCalendar.module.scss';

const getInitialDateIterator = () => {
  let today = getDateAsUTC(new Date());
  today = setDate(today, 1);
  today = setMonth(today, 0);
  return today;
};

const N_MONTHS = 24;

const AvailabilityCalendar = ({
  seasonalPrices = null,
  currency = null,
  unavailabilities = []
}) => {
  let dateIterator = getInitialDateIterator();
  const today = getDateAsUTC(new Date());
  const occupancies = getOccupancies(
    unavailabilities,
    getDateAsUTC(new Date())
  );

  const content = [];
  let monthContent;

  for (let indexMonth = 0; indexMonth < N_MONTHS; indexMonth += 1) {
    const currentMonth = getMonth(dateIterator);
    const currentYear = getYear(dateIterator);

    if (currentMonth === 0 || indexMonth === 0) {
      monthContent = [];

      content.push(
        <div
          key={`${currentYear}-title`}
          className={styles['availability-calendar__year-title']}
        >
          {currentYear}
        </div>
      );
    }

    const monthlyPrice = seasonalPrices
      ? Object.values(seasonalPrices)[currentMonth]
      : null;

    const occupanciesByDate =
      occupancies[currentYear] && occupancies[currentYear][currentMonth]
        ? occupancies[currentYear][currentMonth]
        : [];

    monthContent.push(
      <AvailabilityMonth
        occupanciesByDate={occupanciesByDate}
        daysToNow={getDaysDiff(dateIterator, today)}
        daysInMonth={getDaysInMonth(dateIterator)}
        year={currentYear}
        month={currentMonth}
        monthLabel={formatMonthAbbrvDate(dateIterator)}
        key={`${currentYear}-${indexMonth}`}
        price={monthlyPrice}
        currency={currency}
      />
    );

    if (currentMonth === 11 || indexMonth === N_MONTHS - 1) {
      content.push(
        <div
          key={`${currentYear}-content`}
          className={styles['availability-calendar__year']}
        >
          {monthContent}
        </div>
      );
    }

    dateIterator = addMonths(dateIterator, 1);
  }

  return (
    <div>
      <div className={styles['availability-calendar__wrapper']}>{content}</div>
      <div className={styles['availability-calendar__legend-wrapper']}>
        <div
          className={classNames([
            styles['availability-calendar__legend'],
            styles['availability-calendar__legend--green']
          ])}
        >
          {trans('availability_calendar.legend.available')}
        </div>
        <div
          className={classNames([
            styles['availability-calendar__legend'],
            styles['availability-calendar__legend--red']
          ])}
        >
          {trans('availability_calendar.legend.occupied')}
        </div>
      </div>
    </div>
  );
};

AvailabilityCalendar.propTypes = {
  unavailabilities: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string
    })
  ),
  currency: PropTypes.string, // €, $, ...
  seasonalPrices: PropTypes.shape({
    jan: PropTypes.number,
    feb: PropTypes.number,
    mar: PropTypes.number,
    apr: PropTypes.number,
    may: PropTypes.number,
    jun: PropTypes.number,
    jul: PropTypes.number,
    aug: PropTypes.number,
    sep: PropTypes.number,
    oct: PropTypes.number,
    nov: PropTypes.number,
    dec: PropTypes.number
  })
};

export default AvailabilityCalendar;
